<template>
    <v-container grid-list-lg style="max-width: 1240px" class="py-3 px-0 osago-doc-type">
        <v-layout>
            <v-flex pb-0>
                <h3 style="display: inline-block;">
                    Тип документа на транспортное средство
                    <v-progress-circular
                        v-if="gibddInfoLoading"
                        class="ml-1"
                        indeterminate
                        color="#00ba57"
                        size="10"
                        width="2"
                    />
                </h3>
                <v-progress-circular
                    v-if="showCarDocLoader"
                    class="ml-2"
                    indeterminate
                    color="#00ba57"
                    size="20"
                    width="2"
                />
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex py-0 style="margin-bottom: -25px">
                <v-radio-group row
                    v-model="value.type"
                    :disabled="disabled || numberInfoLoading"
                    @change="value.seriesNumber=''"
                >
                    <v-radio label="ПТС"
                             value="pts"
                             class="pb-3">
                    </v-radio>
                    <v-radio label="ЭПТС"
                             value="epts"
                             class="pb-3">
                    </v-radio>
                    <v-radio label="СРТС — свидетельство о регистрации транспортного средства"
                             value="srts"
                             class="pb-3">
                    </v-radio>
                    <v-radio v-if="category === 'T'"
                             label="ПСМ – паспорт самоходного средства"
                             value="psm"
                             class="pb-3">
                    </v-radio>
                    <v-radio v-if="category === 'T'"
                             label="ЭПСМ – электронный паспорт самоходного средства"
                             value="epsm"
                             class="pb-3">
                    </v-radio>
                </v-radio-group>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12 sm6 md3 lg3 py-0>
                <v-text-field
                        v-if="value.type==='pts'"
                        v-model="value.seriesNumber"
                        :rules="[rules.required, rules.pts]"
                        @paste="removeSpacesOnPaste($event, value.seriesNumber)"
                        mask="##RR ######"
                        return-masked-value
                        label="Серия и номер"
                        validate-on-blur
                        required
                        :disabled="disabled || numberInfoLoading"
                ></v-text-field>
                <v-text-field
                    v-if="value.type==='srts'"
                    v-model="value.seriesNumber"
                    :rules="[rules.required, rules.pts]"
                    @paste="handlePaste($event)"
                    :mask="mask"
                    return-masked-value
                    label="Серия и номер"
                    validate-on-blur
                    required
                    :disabled="disabled || numberInfoLoading"
                    @input="updateMask"
                />
                <v-text-field
                        v-if="value.type==='epts'"
                        v-model="value.seriesNumber"
                        :rules="[rules.required, rules.srts]"
                        @paste="removeSpacesOnPaste($event, value.seriesNumber)"
                        mask="###############"
                        return-masked-value
                        label="Номер"
                        validate-on-blur
                        required
                        :disabled="disabled || numberInfoLoading"
                ></v-text-field>
                <v-text-field
                    v-if="value.type==='psm'"
                    v-model="value.seriesNumber"
                    :rules="[rules.required, rules.psm]"
                    @paste="removeSpacesOnPaste($event, value.seriesNumber)"
                    mask="SS ######"
                    return-masked-value
                    label="Серия и номер"
                    validate-on-blur
                    required
                    :disabled="disabled || numberInfoLoading"
                ></v-text-field>
                <v-text-field
                    v-if="value.type==='epsm'"
                    v-model="value.seriesNumber"
                    :rules="[rules.required, rules.epsm]"
                    @paste="removeSpacesOnPaste($event, value.seriesNumber)"
                    mask="###############"
                    return-masked-value
                    label="Номер"
                    validate-on-blur
                    required
                    :disabled="disabled || numberInfoLoading"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3 lg2 pt-0>
                <osago-date v-model="value.date"
                            label="Дата выдачи"
                            :max="dateToday"
                            :is-disabled="disabled || gibddInfoLoading"
                            :isHideMobile="true"
                            :min="carProdYear ? carProdYear+'-01-01' : null"
                />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import helperMixin from '../../mixins/helper';

    export default {
        mixins: [helperMixin],
        name: "CarDoc",

        props: [
            'value',
            'yearIssue',
            'dateToday',
            'disabled',
            'showCarDocLoader',
            'numberInfoLoading',
            'gibddInfoLoading',
            'carProdYear',
            'category'
        ],

        data: () => ({
            rules: {
                required: v => !!v || 'Обязательное поле',
                pts: v => /^\d{2}[\dА-ЯA-Z]{2} \d{6}$/.test(v) || /^[A-Za-zА-Яа-яЁё]{2} \d{6}$/.test(v) || 'Неверный формат',
                psm: v => /^[A-ZА-Я]{2} \d{6}$/.test(v) || 'Неверный формат',
                srts: v => /^\d{15}$/.test(v) || 'Неверный формат',
                epsm: v => /^\d{15}$/.test(v) || 'Неверный формат',
            },
            mask: "S",
        }),

        created() {
            if (this.value && this.value.seriesNumber) {
                this.updateMask();
            }
        },

        methods: {
            updateMask() {
                const firstChar = this.value.seriesNumber.charAt(0);

                if (/^[A-Za-zА-Яа-яЁё]$/.test(firstChar)) {
                    this.mask = "RR ######";
                } else if (/^\d$/.test(firstChar)) {
                    this.mask = "##SS ######";
                } else {
                    this.mask = "S";
                }
            },
            handlePaste(event) {
                const pastedText = event.clipboardData.getData('text').trim();
                if (!pastedText) return;

                const firstChar = pastedText.charAt(0);

                if (/^[A-Za-zА-Яа-яЁё]$/.test(firstChar)) {
                    this.mask = "RR ######";
                } else if (/^\d$/.test(firstChar)) {
                    this.mask = "##SS ######";
                } else {
                    this.mask = "S";
                }

                this.$nextTick(() => {
                    this.value.seriesNumber = pastedText;
                });

                event.preventDefault();
            }
        },

        watch: {
            'value.seriesNumber': {
                handler() {
                    this.updateMask();
                    console.log('this.value.seriesNumber')
                },
                deep: true
            },
        },

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/components/fields/CarDoc.vue